/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Confetti } from './Confetti';
import styles from './index.module.css';

const NUM_CONFETTI = 350;
export class Celebration extends PureComponent {
  static propTypes = {
    palette: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  };

  componentDidMount() {
    this.generateConfetti(this.props.palette);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.palette !== this.props.palette) {
      this.generateConfetti(nextProps.palette);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setCanvasDimensions, false);
  }

  setCanvasDimensions = () => {
    const canvas = this.canvas;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  };

  generateConfetti = palette => {
    if (palette.length) {
      const canvas = this.canvas;
      const context = canvas.getContext('2d');

      window.addEventListener('resize', this.setCanvasDimensions, false);
      this.setCanvasDimensions();

      const confetti = [];
      for (let j = 1; j <= NUM_CONFETTI; j += 1) {
        confetti.push(new Confetti(canvas, palette));
      }

      const step = () => {
        requestAnimationFrame(step);
        context.clearRect(0, 0, canvas.width, canvas.height);
        const results = [];
        for (let j = 0, len = confetti.length; j < len; j += 1) {
          const c = confetti[j];
          results.push(c.draw());
        }
        return results;
      };

      step();
    }
  };

  render() {
    return (
      <canvas
        className={styles.confetti}
        ref={c => {
          this.canvas = c;
        }}
      />
    );
  }
}
